// extracted by mini-css-extract-plugin
export default {"meControlFallback":"tVFID","meControlFallbackInitials":"YMJMy"};